import { render, staticRenderFns } from "./app_version_add.vue?vue&type=template&id=d1411cf8"
import script from "./app_version_add.vue?vue&type=script&lang=js"
export * from "./app_version_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports